var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Banner',{attrs:{"show":true,"text":_vm.$t('main.searchResult.banner.giveFeedback'),"button-text":_vm.$t('main.searchResult.banner.feedbackButton'),"button-link":_vm.feedbackBannerUrl,"bold-text":''}})
}
var staticRenderFns = []

export { render, staticRenderFns }